let store = require("../store");
let actions = require("../actions");

let Table = mc.widgets.Table;

class EquipmentLogView extends React.Component {
  constructor(props) {
    super(props);

    this.state = this.getInitialState();
  }

  getInitialState() {
    let sn = this.props.serialNumber;

    return {
      equipmentLog: store.getState().equipmentLog[sn] || [],
      prefs: store.getState().prefs
    };
  }

  componentDidMount() {
    this.unsubscribe = store.subscribe(this.handleStoreChange.bind(this));

    let accountId = store.getState().accountId;
    let serialNumber = this.props.serialNumber;

    actions.loadEquipmentLog(accountId, serialNumber);
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  handleStoreChange() {
    this.setState(this.getInitialState());
  }

  setSort(key, direction) {
    actions.setPref("dateSortDirection", direction);
  }

  static open(serialNumber, type) {
    mc.ui.modal(<EquipmentLogView serialNumber={serialNumber} type={type}/>);
  }

  render() {
    let { serialNumber, type } = this.props;
    let { equipmentLog, prefs } = this.state;

    let data = equipmentLog.map(function (entry, i) {
      entry.idx = i;
      return entry;
    });

    let cols = [
      {
        prop: "createdTs",
        label: tx("date_time"),
        content: function (result) {
          return mc.format.datetime(result.createdTs);
        },
        width: "30%",
        sort: true
      },
      {
        prop: "study",
        label: tx("study_id"),
        content: function (result) {
          return result.study.displayName;
        },
        width: "25%"
      },
      {
        prop: "subject",
        label: tx("subject_id"),
        content: function (result) {
          return result.subject.displayName;
        },
        width: "25%"
      },
      {
        prop: "state",
        label: tx("status"),
        content: function (result) {
          return tx("state." + result.state);
        },
        width: "20%"
      }
    ];

    return (
      <div className="mc-equipment-log-view" data-type={type}>
        <h1>{serialNumber}</h1>
        <Table
          data={data}
          cols={cols}
          rowKey="idx"
          sort="createdTs"
          direction={prefs.dateSortDirection}
          onSort={this.setSort.bind(this)}/>
      </div>
    );
  }
}

module.exports = EquipmentLogView;